import React from 'react'
import { Stack, Tooltip } from '@mui/material'
import FileCopyIcon from '@mui/icons-material/FileCopy';
import useNodeCRUD from '../hooks/useNodeCRUD';


export default function NodeWrapper({ nodeId, children }) {

    const { onNodeClone, onNodeDelete } = useNodeCRUD()

    return (
        <Stack position={'relative'}>
            <Tooltip title="delete">
                <div className='ghost-btn close' onClick={() => onNodeDelete(nodeId)}>X</div>
            </Tooltip>
            <Tooltip title="clone">
                <div className='ghost-btn clone' onClick={e => onNodeClone(e, nodeId)}><FileCopyIcon sx={{ width: '80%', height: '80%' }} /></div>
            </Tooltip>
            {children}
        </Stack>
    )
}
